// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarTooltip_root__20By1","text":"SidebarTooltip_text__2Cb5a"};